import type { paths } from "../../../__definitions__/self-driving.changeengine.com-definitions";

export type CreateContentRequest = {
  q: string;
  format?: string;
  tone?: string;
  image_style?: {
    photo: boolean;
    illustration: boolean;
    icon: boolean;
    video: boolean;
  };
  file?: {
    id?: string;
    name?: string;
  };
  db?: string;
};
export type Multiformat =
  paths["/multiformat"]["get"]["responses"]["200"]["content"]["application/json"];
export type MultiformatConfig = Multiformat["content_types"][0];
export type MultiformatDimensions = { width: number | null; height: number | null };

export type ContentTypeOption = {
  label: string;
  value: string;
};

export const isLongform = (
  format: string | undefined,
): format is "FAQ" | "Manager One-Pager" | "Guide" | "Multipage FAQ" =>
  ["FAQ", "Manager One-Pager", "Guide", "Multipage FAQ"].includes(format!);

export type MultiformatImage =
  Multiformat["content_types"][number]["layouts"][number]["images"][number];
export type MultiformatImageType =
  paths["/multiformat"]["get"]["responses"][200]["content"]["application/json"]["content_types"][0]["layouts"][0]["images"][0]["type"];
export type MultiformatImageOrientation =
  paths["/multiformat"]["get"]["responses"][200]["content"]["application/json"]["content_types"][0]["layouts"][0]["images"][0]["orientation"];

export type MultiformatLayout =
  paths["/multiformat"]["get"]["responses"][200]["content"]["application/json"]["content_types"][0]["layouts"][0];
